module.exports = __webpack_public_path__ + "img/Image4.00ee0bc1.webp";